module.exports = __webpack_public_path__ + "static/how-it-fits-64bf18343b5b48d7ff2234b4504c5bf7.jpg";